import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Building2, Home, LayoutDashboard, ScrollText, UsersRound } from "lucide-react";
import WhatsAppIcon from "../WhatsAppIcon";
import useAuth from "../../hooks/useAuth";
import AI_PDF_CONST from "../../util/PdfAiConst";
import { can, canAccessWorkspace, isClientAdmin, isPlatformAdmin } from "../../util/accessControl";

const Topbar = ({ mobile = false, onNavigate }) => {
  const { user } = useAuth();
  const location = useLocation();
  const base = AI_PDF_CONST.ROUTE;
  const platform = isPlatformAdmin(user);
  const botHome = location.pathname === "/agents";
  const homePage = ["/", "/home"].includes(location.pathname);
  const workspaceLabel = !platform && homePage ? "Workspace" : "Home";
  const items = [
    ...((botHome || !platform) && canAccessWorkspace(user) ? [{ label: workspaceLabel, to: "/agents", Icon: Home }] : []),
    ...(isClientAdmin(user) ? [{ label: "Dashboard", to: base.ADMIN_DASHBOARD, Icon: LayoutDashboard }] : []),
    ...(platform ? [{ label: "Clients", to: "/clients", Icon: Building2 }] : []),
    ...(isClientAdmin(user) && user?.client_id != null ? [
      { label: "Team", to: `/clients/${user.client_id}/users`, Icon: UsersRound },
      { label: "Roles", to: `/clients/${user.client_id}/roles`, Icon: UsersRound },
    ] : []),
  ];
  if (!platform && !botHome && !homePage && can(user, "inbox.read")) {
    items.push({ label: "Inbox", to: base.ADMIN_WHATSAPP_INBOX, Icon: WhatsAppIcon });
  }
  if (platform) {
    items.push({ label: "Audit logs", to: base.ADMIN_AUDIT_LOGS, Icon: ScrollText });
  }
  const isActive = (item) => {
    const [path, query] = item.to.split("?");
    const pathMatches = location.pathname === path || location.pathname.startsWith(`${path}/`);
    const tab = new URLSearchParams(query).get("tab");
    return pathMatches && (!tab || new URLSearchParams(location.search).get("tab") === tab);
  };

  if (items.length === 0) return null;

  return (
        <nav aria-label="Workspace navigation" className={mobile ? "grid gap-1" : "flex min-w-0 items-center gap-1"}>
          {items.map(({ Icon, ...item }, index) => {
            const active = isActive(item) && !items.slice(0, index).some(isActive);
            return <NavLink key={item.label} to={item.to} onClick={onNavigate} aria-current={active ? "page" : undefined} className={() => `inline-flex min-h-10 shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold ${active ? "bg-cyan-50 text-cyan-900" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"}`}>
              <Icon size={17} /><span className="whitespace-nowrap">{item.label}</span>
            </NavLink>;
          })}
        </nav>
  );
};

export default Topbar;
